var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserNationality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2295 2.73881C20.0686 2.65764 19.8743 2.68362 19.7404 2.80431C18.557 3.86545 17.4697 4.38073 16.4129 4.38073C15.3561 4.38073 14.3299 3.89165 13.0548 2.78684C10.2863 0.424399 7.56573 0.428766 4.38669 2.68641C4.16398 2.84361 4.16398 2.84361 4.20328 7.38946C4.20328 9.17549 4.23385 11.3895 4.20328 11.6995C4.14291 11.933 4.28325 12.1712 4.51671 12.2316C4.65711 12.2679 4.80634 12.2322 4.91507 12.1362C6.02321 11.2813 7.37605 10.8038 8.77534 10.7737C9.68653 10.7787 10.5839 10.9971 11.3954 11.4113C12.2823 11.8867 13.2674 12.1498 14.2732 12.1799C19.5483 12.1799 20.4173 3.54667 20.4522 3.17986C20.4763 3.00093 20.3878 2.82565 20.2295 2.73881Z",
    fill: "#4C4F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85836 0H2.44788C1.94864 0 1.54395 0.404694 1.54395 0.90393V21.0961C1.54395 21.5953 1.94864 22 2.44788 22H2.85836C3.35759 22 3.76229 21.5953 3.76229 21.0961V0.90393C3.76229 0.404694 3.35759 0 2.85836 0Z",
    fill: "#4C4F5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNationality);
export default __webpack_public_path__ + "static/media/user-nationality.dc5c0c1f285a870d4aa0b4c3bb00a2b9.svg";
export { ForwardRef as ReactComponent };